import { type CrossSellProduct } from '@redteclab/api/clients/retail-media-xsell-service/models'

import { useExperimentsContext } from '../components/ExperimentsContext'

import { experimentsCompeteraExperimentIsEnabledAndV1 } from './experimentsCompeteraExperiment'

export type CrossSellProductPricePropsEnhancedWithCompetera = {
  product?: CrossSellProduct & {
    new_baseprice_tsta?: string
    price_tsta?: string
  }
}

export const useCompeteraPriceIfNeeded = (
  product?: CrossSellProductPricePropsEnhancedWithCompetera['product'],
): {
  newBasePrice: string
  price: string
} => {
  const { experiments } = useExperimentsContext()

  if (!product) {
    return {
      newBasePrice: '',
      price: '',
    }
  }

  if (experimentsCompeteraExperimentIsEnabledAndV1(experiments)) {
    return {
      newBasePrice: product.new_baseprice_tsta ?? product.new_baseprice,
      price: product.price_tsta ?? product.price,
    }
  }

  return {
    newBasePrice: product.new_baseprice,
    price: product.price,
  }
}
